// 竞赛id
export const COMPET_ID = ''

// 竞赛字典code
export const COMPET_CODE = 'heroic'

// 竞赛分类id
export const COMPET_CLASSIFY_ID = 3

// 接口前缀
export const PREFIX_API =  '/admin-api/'

// 竞赛主题名称
export const COMPET_NAME = '英烈精神·传承有我'

// 届数
export const SESSIONS_NUMBER = ''

// 主题颜色
export const COMPET_THEME = '#a72126'

// 底部备案号
export const FILING_NUMBER = ''



// WEBPACK FOOTER //
// ./src/utils/config.js